module.exports = __webpack_public_path__ + "img/doorLogo31.860c2654.png";